<template>
    <div>
        <img :src="iconImg" alt="" class="file-format-icon"/>
    </div>
</template>

<script>
import sevenZIcon from '@/assets/images/fileFormatIcon/7z.svg'
import avIcon from '@/assets/images/fileFormatIcon/av.svg'
import aviIcon from '@/assets/images/fileFormatIcon/avi.svg'
import bmpIcon from '@/assets/images/fileFormatIcon/bmp.svg'
import bzipIcon from '@/assets/images/fileFormatIcon/bzip.svg'
import cssIcon from '@/assets/images/fileFormatIcon/css.svg'
import csvIcon from '@/assets/images/fileFormatIcon/csv.svg'
import docIcon from '@/assets/images/fileFormatIcon/doc.svg'
import docxIcon from '@/assets/images/fileFormatIcon/docx.svg'
import flacIcon from '@/assets/images/fileFormatIcon/flac.svg'
import gifIcon from '@/assets/images/fileFormatIcon/gif.svg'
import gzIcon from '@/assets/images/fileFormatIcon/gz.svg'
import gzipIcon from '@/assets/images/fileFormatIcon/gzip.svg'
import htmIcon from '@/assets/images/fileFormatIcon/htm.svg'
import htmlIcon from '@/assets/images/fileFormatIcon/html.svg'
import icoIcon from '@/assets/images/fileFormatIcon/ico.svg'
import jpegIcon from '@/assets/images/fileFormatIcon/jpeg.svg'
import jpgIcon from '@/assets/images/fileFormatIcon/jpg.svg'
import jsIcon from '@/assets/images/fileFormatIcon/js.svg'
import jsonIcon from '@/assets/images/fileFormatIcon/json.svg'
import movIcon from '@/assets/images/fileFormatIcon/mov.svg'
import mp3Icon from '@/assets/images/fileFormatIcon/mp3.svg'
import mp4Icon from '@/assets/images/fileFormatIcon/mp4.svg'
import mpegIcon from '@/assets/images/fileFormatIcon/mpeg.svg'
import odpIcon from '@/assets/images/fileFormatIcon/odp.svg'
import odsIcon from '@/assets/images/fileFormatIcon/ods.svg'
import odtIcon from '@/assets/images/fileFormatIcon/odt.svg'
import oggIcon from '@/assets/images/fileFormatIcon/ogg.svg'
import pdfIcon from '@/assets/images/fileFormatIcon/pdf.svg'
import pngIcon from '@/assets/images/fileFormatIcon/png.svg'
import pptIcon from '@/assets/images/fileFormatIcon/ppt.svg'
import pptxIcon from '@/assets/images/fileFormatIcon/pptx.svg'
import psdIcon from '@/assets/images/fileFormatIcon/psd.svg'
import rarIcon from '@/assets/images/fileFormatIcon/rar.svg'
import rtfIcon from '@/assets/images/fileFormatIcon/rtf.svg'
import svgIcon from '@/assets/images/fileFormatIcon/svg.svg'
import tiffIcon from '@/assets/images/fileFormatIcon/tiff.svg'
import txtIcon from '@/assets/images/fileFormatIcon/txt.svg'
import urlIcon from '@/assets/images/fileFormatIcon/url.svg'
import wavIcon from '@/assets/images/fileFormatIcon/wav.svg'
import webmIcon from '@/assets/images/fileFormatIcon/webm.svg'
import webpIcon from '@/assets/images/fileFormatIcon/webp.svg'
import wmvIcon from '@/assets/images/fileFormatIcon/wmv.svg'
import xlsxIcon from '@/assets/images/fileFormatIcon/xlsx.svg'
import xmlIcon from '@/assets/images/fileFormatIcon/xml.svg'
import xlsIcon from '@/assets/images/fileFormatIcon/xls.svg'
import zipIcon from '@/assets/images/fileFormatIcon/zip.svg'
import unknownFormatIcon from '@/assets/images/fileFormatIcon/unknownFormat.svg' 
export default {
    props: {
        url: {
            type: String,
            default: ''
        },
        fileName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            formats: [
                {format: '7z', icon: sevenZIcon},
                {format: 'av', icon: avIcon},
                {format: 'avi', icon: aviIcon},
                {format: 'bmp', icon: bmpIcon},
                {format: 'bzip', icon: bzipIcon},
                {format: 'css', icon: cssIcon},
                {format: 'csv', icon: csvIcon},
                {format: 'doc', icon: docIcon},
                {format: 'docx', icon: docxIcon},
                {format: 'flac', icon: flacIcon},
                {format: 'gif', icon: gifIcon},
                {format: 'gz', icon: gzIcon},
                {format: 'gzip', icon: gzipIcon},
                {format: 'htm', icon: htmIcon},
                {format: 'html', icon: htmlIcon},
                {format: 'ico', icon: icoIcon},
                {format: 'jpeg', icon: jpegIcon},
                {format: 'jpg', icon: jpgIcon},
                {format: 'js', icon: jsIcon},
                {format: 'json', icon: jsonIcon},
                {format: 'mov', icon: movIcon},
                {format: 'mp3', icon: mp3Icon},
                {format: 'mp4', icon: mp4Icon},
                {format: 'mpeg', icon: mpegIcon},
                {format: 'odp', icon: odpIcon},
                {format: 'ods', icon: odsIcon},
                {format: 'odt', icon: odtIcon},
                {format: 'ogg', icon: oggIcon},
                {format: 'pdf', icon: pdfIcon},
                {format: 'png', icon: pngIcon},
                {format: 'ppt', icon: pptIcon},
                {format: 'pptx', icon: pptxIcon},
                {format: 'psd', icon: psdIcon},
                {format: 'rar', icon: rarIcon},
                {format: 'rtf', icon: rtfIcon},
                {format: 'svg', icon: svgIcon},
                {format: 'tiff', icon: tiffIcon},
                {format: 'txt', icon: txtIcon},
                {format: 'url', icon: urlIcon},
                {format: 'wav', icon: wavIcon},
                {format: 'webm', icon: webmIcon},
                {format: 'webp', icon: webpIcon},
                {format: 'wmv', icon: wmvIcon},
                {format: 'xlsx', icon: xlsxIcon},
                {format: 'xml', icon: xmlIcon},
                {format: 'xls', icon: xlsIcon },
                {format: 'zip', icon: zipIcon},
            ]
        }
    },
    computed: {
        iconImg() {
            const formatMatch = this.url.match(/(?<=\.)[^.]+$/)
            const fileNameFormatMatch = this.fileName.match(/(?<=\.)[^.]+$/)
            if (formatMatch) {
                const formatItem = this.formats.find(item => item.format === formatMatch[0])
                if (formatItem && this.formats.some(item => item.format === formatItem.format)) {
                    return formatItem.icon
                } else if (formatMatch[0].length < 7 && fileNameFormatMatch && formatMatch[0] === fileNameFormatMatch[0]) {
                    return unknownFormatIcon
                }
            }
            return urlIcon
        }
    }
}
</script>

<style>
.file-format-icon {
    height: 45px;
    width: 45px;
    margin-right: 16px;
}
</style>